export const translations = {
  codigo: {
    pt: 'Código',
    en: 'Code',
    de: 'Code',
    es: 'Código',
  },
  nome: {
    pt: 'Nome',
    en: 'Name',
    de: 'Name',
    es: 'Nombre',
  },
  transportadora: {
    pt: 'Transportadora',
    en: 'Carrier',
    de: 'Carrier',
    es: 'Transportadora',
  },
  area: {
    pt: 'Área',
    en: 'Area',
    de: 'Area',
    es: 'Área',
  },
  funcao: {
    pt: 'Função',
    en: 'Role',
    de: 'Role',
    es: 'Función',
  },
  email: {
    pt: 'Email',
    en: 'Email',
    de: 'Email',
    es: 'Email',
  },
  telefone: {
    pt: 'Telefone',
    en: 'Phone',
    de: 'Phone',
    es: 'Teléfono',
  },
};
